import { getPPartLabel } from '@parallel-fluidics/shared/models/projects/parts';

/**
 * The standard select option for a project part: the shared label
 * ("0069-A-COC (Anti-backflow reservoir - Product)") with the part's
 * status as the option tag. Call sites spread extra fields on top.
 */
export default function getPPartOption(part) {
  return {
    label: getPPartLabel(part),
    labelTag: part.status,
    value: part.id,
  };
}
